module.exports = __webpack_public_path__ + "img/one.c016b30d.png";